export const formatPrice = (value) => {
  const strippedValue = value?.toString()?.replace(/,/g, "");
  const numericValue = parseFloat(strippedValue);
  const formattedValue = numericValue?.toLocaleString();
  return formattedValue;
};
